import defapower from '../../assets/images/defapower.png'
import DEFACharger from '../DEFACharger/DEFACharger'
import MobileCoverage from '../MobileCoverage/MobileCoverage';
import Button from '../Button/Button';
import { useLocation, useParams } from 'react-router-dom';
import picture from '../../assets/images/green-bars.svg'
import { useEffect, useState } from 'react';
import Spinner from '../Spinner/Spinner';
import TermsAndCond from '../TermsAndCond/TermsAndCond';
import CurrencyOption from '../CurrencyOption/CurrencyOption';
import AppViewNav from '../AppViewNav/AppViewNav';

const BACKEND_HOST = process.env.REACT_APP_BACKEND_URL ? process.env.REACT_APP_BACKEND_URL : "http://localhost:8080";
let HOST;
if (window.location.port.length > 0) {
    HOST = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port
} else {
    HOST = window.location.protocol + "//" + window.location.hostname
}


const Coverage = () => {
    let { serialNumber } = useParams();
    let { pathname } = useLocation();

    const [valid, setValid] = useState(false);
    const [paymentAllowed, setPaymentAllowed] = useState(false);
    const [paymentRejectionReason, setPaymentRejectionReason] = useState("");
    const [paymentRejectionReasonDetail, setPaymentRejectionReasonDetail] = useState("");
    const [loading, setLoading] = useState(true);
    const [prices, setPrices] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState("");

    const urlParams = new URLSearchParams(window.location.search);

    useEffect(() => {
        fetch(`${BACKEND_HOST}/checkout/${serialNumber}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`This is an HTTP error: The status is ${response.status}`)
                }
                setValid(true)
                return fetch(`${BACKEND_HOST}/checkout/${serialNumber}/payment-allowed`)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`This is an HTTP error: The status is ${response.status}`)
                }
                return response.json()
            })
            .then(response => {
                setPaymentAllowed(response.allowed)
                setPaymentRejectionReason(response.rejectionReason)
                setPaymentRejectionReasonDetail(response.rejectionReasonDetail)
            })
        .catch(x => console.log("Error External: ", x.message))
        .finally(x => setLoading(false));
    }, [serialNumber]);

    useEffect(() => {
        fetch(`${BACKEND_HOST}/checkout/prices`)
        .then(res => res.json())
        .then(val => {
            setPrices(val.prices);
            const defaultCurrency = val.prices.find(x => x.defaultPrice)
            if(defaultCurrency) {
                setSelectedCurrency(defaultCurrency);
            }
        })
        .catch(x => console.error("Error getting prices: ", x.message));
    },[]);

    const createCheckoutSessionPayload = () => {
        return {
            method: "POST",
            body:
                JSON.stringify({
                    successUrl: createSuccessUrl(),
                    cancelUrl: createCancelUrl(),
                    priceId: selectedCurrency.priceId,
                    currency: selectedCurrency.currency
                }),
                headers: {
                    "Content-Type": "application/json",
                }
        }
    }
    const displayCurrency = () => {
        return `${selectedCurrency.price} ${selectedCurrency.currency.toUpperCase()}`
    }
    const createSuccessUrl = () => {
        if (urlParams.size > 0) {
            return `${HOST}/power/${serialNumber}/success?${urlParams.toString()}`
        }
        return `${HOST}/power/${serialNumber}/success`

    };

    const createCancelUrl = () => {
        if (urlParams.size > 0) {
            return `${HOST}/power/${serialNumber}/cancel?${urlParams.toString()}`
        }
        return `${HOST}/power/${serialNumber}/cancel`
    };

    const isAppView = () => {
        const params = Object.fromEntries(urlParams.entries());
        return params.hasOwnProperty('app');
    }
    const purchase = () => {
        fetch(`${BACKEND_HOST}/checkout/${serialNumber}/create-checkout-session`, createCheckoutSessionPayload())
        .then(response => {
            if(!response.ok) {
                throw new Error(`This is an HTTP error: The status is ${response.status}`)
            }
            return response.json()
        })
        .then(data => redirect(data.url))
        .catch(x => console.error("ERROR CREATING CHECKOUT SESSION"))
    }

    if (loading) {
        return (
            <Spinner />
        )
    }

    if(!valid) {
        return (
        <div>
            <MobileCoverage
                headerText={"Serial number does not exist."}
            />
            <Button displayText={"Back"} buttonAction={() => handleRoute()} />
        </div>
        )
    }

    if (pathname.includes("success")) {
        return (
            <div style={{justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
                <DEFACharger csId={serialNumber} imageLogo={defapower}/>
                <MobileCoverage
                    headerText={"Mobile network activated on DEFA Power"}
                    bodyText={["Your charging station will be online within 24 hours.", "You may power off/on your charging station to trigger a connection immediately."]}
                    pic={picture}
                />
                {isAppView() ? <></> :
                    < AppViewNav
                        showNavigation={true}
                        redirect={redirect}
                    />
                }
            </div>
        )
    }

    if (pathname.includes("cancel")) {
        return (
            <div>
                <DEFACharger csId={serialNumber} imageLogo={defapower}/>
                <MobileCoverage
                    headerText={"Purchase cancelled"}
                    pic={picture}
                />
                {isAppView() ? <></> :
                    < AppViewNav
                        showNavigation={true}
                        redirect={redirect}
                    />
                }
            </div>
        )
    }

    return (
        <div>
            <DEFACharger csId={serialNumber} imageLogo={defapower}/>
            {!paymentAllowed ?
                <>
                    <MobileCoverage
                        headerText={paymentRejectionReason || "A mobile network subscription cannot currently be purchased for this DEFA Power"}
                        bodyText={paymentRejectionReasonDetail ? [paymentRejectionReasonDetail] : undefined}
                        pic={picture}
                    />
                    {isAppView() ? <></> :
                        < AppViewNav
                            showNavigation={true}
                            redirect={redirect}
                        />
                    }
                </>
                :
                <>
                    <MobileCoverage
                        headerText={"Stay connected, anywhere."}
                        bodyText={["Activate internet access immediately on this DEFA Power without any additional setup.", "Note! Using DEFA Power with DEFA Balancer requires Wi-Fi or Ethernet connection"]}
                        pic={picture}
                    />
                    {prices.length >= 2 ? <CurrencyOption list={prices} callback={setSelectedCurrency} /> : <></>}
                    {selectedCurrency !== "" ? <Button displayText={`Buy now for ${displayCurrency()}`} buttonAction={() => purchase()} /> : <></>}
                    <TermsAndCond text={"By continuing to check out, you accept "} link={"https://www.defa.com/terms-mobile-services"} />
                </>
            }
        </div>
    );
}

const handleRoute = () => {
    window.location.href = "/";
}

const redirect = (url) => {
    window.location.href = url;
}

export default Coverage;